export default {
  shapes: [],
  shapesByKeywords: [],
  list: [],
  read: {},
};
